import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { UtilitiesService } from './services/utilities.service';

@Injectable()
export class LoginRouteGuard implements CanActivate {

  constructor(private utilService: UtilitiesService) {}

  canActivate() {
      // return this.loginService.isLoggedIn();
      //this.utilService.doAudit(this.utilService.isUserValidated(), 'loginrouteguard');
      return true;
      //return this.utilService.isUserValidated();
  }
}